const deleteChecklistButton = {
  text: 'Apagar Checklist'
};

export default deleteChecklistButton;
